export const TRANSITION_DURATION = 'duration-200';
export const TRANSITION_EASING = 'ease-[cubic-bezier(0.4,0,0.6,1)]';
export const HOVER_CLOSE_DELAY = 100;

export const NAV_ITEM_BASE_CLASSES = [
  'group flex items-center px-4 py-2',
  'text-sm font-normal leading-5 text-gray-blue-80',
  'transition-colors duration-150',
  'outline-none focus-visible:ring-2 focus-visible:ring-green-400 focus-visible:ring-offset-2',
  'hover:bg-sidebar-hover hover:text-gray-blue-90',
] as const;

export const LABEL_ANIMATION_BASE_CLASSES = [
  'whitespace-nowrap overflow-hidden',
  `transition-all ${TRANSITION_DURATION} ${TRANSITION_EASING}`,
] as const;

export const LABEL_COLLAPSED_CLASSES = 'opacity-0 max-w-0 ml-0 -translate-x-2';
export const LABEL_EXPANDED_CLASSES = 'opacity-100 max-w-52 ml-3 translate-x-0';

export function getLabelAnimationClasses(isCollapsed: boolean): string[] {
  return [
    ...LABEL_ANIMATION_BASE_CLASSES,
    isCollapsed ? LABEL_COLLAPSED_CLASSES : LABEL_EXPANDED_CLASSES,
  ];
}
